import React from "react";
import { useStaticQuery, graphql, Link } from "gatsby";
import { ReferenciaMultimedia } from "../../../interfaces/ReferenciaMultimedia";
import { CONTENT_TYPE_ARTICULO } from "../../../services/social.services";
import { GatsbyImage, getImage } from 'gatsby-plugin-image';

// Components //
import LikeButton from "../like-button/like-button";

// Helpers //
import { getLastWeeksDays } from "../../../utils/helpers"

// Styles //
import "./mediaCard.scss";

const MediaCard = (props: ReferenciaMultimedia) => {
    const {
        tituloMultimedia,
        textoIntroductorio,
        imagenPrincipal,
        tituloBoton,
        tematica,
        categoriaMultimedia,
        slug,
        parentContentfulId,
        createdAt,
        tituloEvento,
        fechaEvento,
        horaEvento,
        lugarEvento
    } = props;

    const icons = useStaticQuery(graphql`
        query MEDIAICONS {
            iconWebinar: allContentfulAsset(
                filter: { title: { eq: "icon-webinar" } }
            ) {
                nodes {
                    file {
                        url
                    }
                }
            }
            iconPodcast: allContentfulAsset(
                filter: { title: { eq: "icon-podcast" } }
            ) {
                nodes {
                    file {
                        url
                    }
                }
            }
            iconArticulo: allContentfulAsset(
                filter: { title: { eq: "icon-articulo" } }
            ) {
                nodes {
                    file {
                        url
                    }
                }
            }
            iconHistorias: allContentfulAsset(
                filter: { title: { eq: "icon-historias" } }
            ) {
                nodes {
                    file {
                        url
                    }
                }
            }
            iconLike: allContentfulAsset(
                filter: { title: { eq: "icon-like" } }
            ) {
                nodes {
                    file {
                        url
                    }
                }
            }
            iconConversatorio: allContentfulAsset(
                filter: { title: { eq: "icon-conversatorio" } }
            ) {
                nodes {
                    file {
                        url
                    }
                }
            }
            iconMarterclass: allContentfulAsset(
                filter: { title: { eq: "icon-masterclass" } }
            ) {
                nodes {
                    file {
                        url
                    }
                }
            }
            iconFeria: allContentfulAsset(
                filter: { title: { eq: "icon-feria" } }
            ) {
                nodes {
                    file {
                        url
                    }
                }
            }
            iconMovil: allContentfulAsset(
                filter: { title: { eq: "icon-movil-empleo" } }
            ) {
                nodes {
                    file {
                        url
                    }
                }
            }
            iconContratacion: allContentfulAsset(
                filter: { title: { eq: "icon-contratacion-masiva" } }
            ) {
                nodes {
                    file {
                        url
                    }
                }
            }
            iconFeriasInstitucionales: allContentfulAsset(
                filter: { title: { eq: "icon-ferias-institucionales" } }
            ) {
                nodes {
                    file {
                        url
                    }
                }
            }
            iconUsuario: allContentfulAsset(
                filter: { title: { eq: "icon-usuario" } }
            ) {
                nodes {
                    file {
                        url
                    }
                }
            }
            iconServicios: allContentfulAsset(
                filter: { title: { eq: "icon-servicios" } }
            ) {
                nodes {
                    file {
                        url
                    }
                }
            }
            iconProyectos: allContentfulAsset(
                filter: { title: { eq: "icon-proyectos" } }
            ) {
                nodes {
                    file {
                        url
                    }
                }
            }
        }
    `);

    const iconConversatorio: string = icons.iconConversatorio.nodes[0].file.url;
    const iconMarterclass: string = icons.iconMarterclass.nodes[0].file.url;
    const iconFeria: string = icons.iconFeria.nodes[0].file.url;
    const iconMovil: string = icons.iconMovil.nodes[0].file.url;
    const iconContratacion: string = icons.iconContratacion.nodes[0].file.url;
    const iconFeriasInstitucionales: string = icons.iconFeriasInstitucionales.nodes[0].file.url;

    const iconWebinar: string = icons.iconWebinar.nodes[0].file.url;
    const iconPodcast: string = icons.iconPodcast.nodes[0].file.url;
    const iconArticulo: string = icons.iconArticulo.nodes[0].file.url;
    const iconHistorias: string = icons.iconHistorias.nodes[0].file.url;
    const iconServicios: string = icons.iconServicios.nodes[0].file.url;
    const iconProyectos: string = icons.iconProyectos.nodes[0].file.url;
    const lastWeekDays = getLastWeeksDays();
    const creatAtCard = new Date(createdAt);

    const ARTICULO = 'VER MAS';
    const WEBINAR = 'VER VIDEO';
    const PODCAST = 'ESCUCHAR';

    const switchIcons = (icon) => {
        switch (icon) {
            case "Artículo":
                return iconArticulo;
            case "Podcast":
                return iconPodcast;
            case "Webinar":
                return iconWebinar;
            case "Historias que conectan":
                return iconHistorias;
            case "Conversatorio":
                return iconConversatorio;
            case "Feria de empleo":
                return iconFeria;
            case "Mentoría":
                return iconConversatorio;
            case "Masterclass":
                return iconMarterclass;
            case "Contratación masiva":
                return iconContratacion;
            case "Móvil de empleo":
                return iconMovil;
            case "Ferias institucionales":
                return iconFeriasInstitucionales;
            case "Servicio de Empleo":
                return iconServicios;
            case "Proyecto":
                return iconProyectos;
            default:
                return "";
        }
    };
    
    //Bloque creado para google tag manager//
    const removeAccents = (str) => {
        return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    }
    const isBrowser = typeof window !== "undefined"
    const pathName = isBrowser ? window.location.pathname: ''
    const tituloMultimediaFixed = removeAccents(tituloMultimedia).replace(/\s+/g, "")
    const tituloMultimediaFixedBib = removeAccents(tituloMultimedia).replace(/\s+/g, "").toLowerCase();
    const gtmBasedOnPathName = () =>{
        return  parentContentfulId === 'lj1mUH5LzFPutJgMsQlPF' || parentContentfulId === '4xmhMfg9xZrUM0riQpUWwK' ?
                    (tituloBoton === 'VER MÁS' ?
                        `gtm_ver_${pathName.split('/')[2]}_${tituloMultimediaFixed}`
                    : tituloBoton === 'INSCRÍBETE AQUÍ' ?
                        `gtm_inscribir_${pathName.split('/')[2]}_${tituloMultimediaFixed}`
                    : tituloBoton === 'CONOCE MÁS AQUÍ' ?    
                        `gtm_conocer_${pathName.split('/')[2]}_${tituloMultimediaFixed}`
                        : ''
                    )
                : parentContentfulId == null && pathName === '/servicio-de-empleo/' ?    
                    (tituloBoton === 'VER MÁS' ?
                        `gtm_ver_general_${tituloMultimediaFixed}`
                    : tituloBoton === 'INSCRÍBETE AQUÍ' ?
                        `gtm_inscribir_general_${tituloMultimediaFixed}`
                    : tituloBoton === 'CONOCE MÁS AQUÍ' ?
                        `gtm_conocer_general_${tituloMultimediaFixed}`
                        : ''
                    )
                : pathName.trim() == `/servicio-de-empleo/${pathName.split('/')[2]}/biblioteca/`
                  || pathName.trim() == `/servicio-de-empleo/${pathName.split('/')[2]}/biblioteca/resultados-busqueda/` ?
                    (removeAccents(tituloBoton).toUpperCase() === ARTICULO ?
                        `gtm_ver_biblio_${pathName.split('/')[2]}_${tituloMultimediaFixedBib}`
                        : tituloBoton.toUpperCase() === WEBINAR ?
                        `gtm_video_biblio_${pathName.split('/')[2]}_${tituloMultimediaFixedBib}`
                        : tituloBoton.toUpperCase() === PODCAST ?
                        `gtm_escuchar_biblio_${pathName.split('/')[2]}_${tituloMultimediaFixedBib}`
                        : ''
                    )
                :'';
    }
    const image = getImage(imagenPrincipal);

    return (
        <div className="m-media-card">
            <div className="m-media-card__image">
                {image && (
                    <GatsbyImage image={image} alt={imagenPrincipal?.description || 'default description'} aria-hidden="true" />
                )}
                {(creatAtCard > lastWeekDays) ? (
                    <span className="m-media-card__image__tag">nuevo</span>
                ) : (
                    null
                )}
            </div>
            <div className="m-media-card__content">
                <div className="m-media-card__content__category">
                    <span className="category">{tematica}</span>
                    <span className="type">
                        <img
                            src={switchIcons(categoriaMultimedia)}
                            alt={categoriaMultimedia}
                        />
                        {categoriaMultimedia}
                    </span>
                </div>
                <div className="m-media-card__content__description">
                    <h3>{tituloMultimedia}</h3>
                    {textoIntroductorio && <p id="textoIntroductorio">{textoIntroductorio}</p>}

                    {/* si la card es de tipo evento renderiza los datos del evento  */}
                    {tituloEvento && <div className="m-media-card__content__description__evento">
                        <div className="m-media-card__content__description__evento__icon">
                            <svg id="calendario" data-name="calendario (17)" xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 24 24">
                                <path id="Trazado_77114" data-name="Trazado 77114" d="M19,2H18V1a1,1,0,1,0-2,0V2H8V1A1,1,0,1,0,6,1V2H5A5.006,5.006,0,0,0,0,7V19a5.006,5.006,0,0,0,5,5H19a5.006,5.006,0,0,0,5-5V7A5.006,5.006,0,0,0,19,2ZM2,7A3,3,0,0,1,5,4H19a3,3,0,0,1,3,3V8H2ZM19,22H5a3,3,0,0,1-3-3V10H22v9A3,3,0,0,1,19,22Z" fill="#474747" />
                                <circle id="Elipse_1952" data-name="Elipse 1952" cx="1.5" cy="1.5" r="1.5" transform="translate(10.5 13.5)" />
                                <circle id="Elipse_1953" data-name="Elipse 1953" cx="1.5" cy="1.5" r="1.5" transform="translate(5.5 13.5)" />
                                <circle id="Elipse_1954" data-name="Elipse 1954" cx="1.5" cy="1.5" r="1.5" transform="translate(15.5 13.5)" />
                            </svg>

                            <p id="fechaEvento">{fechaEvento}</p>
                        </div>

                        <div className="m-media-card__content__description__evento__icon">
                            <span>
                                <svg
                                    id="reloj"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="21"
                                    height="21"
                                    viewBox="0 0 21 21"
                                >
                                    <path
                                        id="Trazado_76052"
                                        data-name="Trazado 76052"
                                        d="M10.5,0A10.5,10.5,0,1,0,21,10.5,10.5,10.5,0,0,0,10.5,0Zm0,19.25a8.75,8.75,0,1,1,8.75-8.75A8.75,8.75,0,0,1,10.5,19.25Z"
                                        transform="translate(0 0)"
                                        fill="#303030"
                                    />
                                    <path
                                        id="Trazado_76053"
                                        data-name="Trazado 76053"
                                        d="M12,6a1,1,0,0,0-1,1v4.325L7.629,13.437a1,1,0,0,0,1.062,1.7l3.84-2.4A1,1,0,0,0,13,11.879V7A1,1,0,0,0,12,6Z"
                                        transform="translate(-1.183 -1.224)"
                                        fill="#303030"
                                    />
                                </svg>
                            </span>
                            <p id="horaEvento">{horaEvento}</p>
                        </div>

                        <div className="m-media-card__content__description__evento__icon">
                            <span>
                                <svg
                                    id="sitio"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="18.025"
                                    height="22.28"
                                    viewBox="0 0 18.025 22.28"
                                >
                                    <g id="Grupo_15515" data-name="Grupo 15515">
                                        <g id="Grupo_15514" data-name="Grupo 15514">
                                            <path
                                                id="Trazado_76055"
                                                data-name="Trazado 76055"
                                                d="M65.294,3.874a9,9,0,0,0-14.79,0,9,9,0,0,0-1.047,8.289,7.085,7.085,0,0,0,1.306,2.156l6.544,7.686a.778.778,0,0,0,1.186,0l6.542-7.684a7.093,7.093,0,0,0,1.306-2.153A9,9,0,0,0,65.294,3.874Zm-.413,7.749a5.557,5.557,0,0,1-1.028,1.683l0,0L57.9,20.3l-5.954-6.994a5.56,5.56,0,0,1-1.029-1.688,7.442,7.442,0,0,1,.87-6.858,7.438,7.438,0,0,1,12.227,0A7.444,7.444,0,0,1,64.881,11.623Z"
                                                transform="translate(-48.886)"
                                                fill="#303030"
                                            />
                                        </g>
                                    </g>
                                    <g
                                        id="Grupo_15517"
                                        data-name="Grupo 15517"
                                        transform="translate(4.28 4.37)"
                                    >
                                        <g id="Grupo_15516" data-name="Grupo 15516">
                                            <path
                                                id="Trazado_76056"
                                                data-name="Trazado 76056"
                                                d="M160.486,106.219a4.732,4.732,0,1,0,4.732,4.732A4.738,4.738,0,0,0,160.486,106.219Zm0,7.775a3.042,3.042,0,1,1,3.042-3.042A3.046,3.046,0,0,1,160.486,113.994Z"
                                                transform="translate(-155.754 -106.219)"
                                                fill="#303030"
                                            />
                                        </g>
                                    </g>
                                </svg>
                            </span>
                            <p id="lugarEvento">{lugarEvento}</p>
                        </div>
                    </div>}
                    <Link 
                        data-recommendation-title={tituloMultimediaFixed} 
                        className={gtmBasedOnPathName()} 
                        to={slug}>
                        <button>{tituloBoton}</button>
                    </Link>
                </div>
                <LikeButton
                    readOnly={true}
                    contentId={parentContentfulId}
                    contentType={CONTENT_TYPE_ARTICULO}
                />
            </div>
        </div>
    );
};

export default MediaCard;
